import { Link } from "react-router-dom";
import { Eyebrow, ArrowRightIcon } from "../../../components/design";

export type CrossLink = { to: string; label: string; blurb: string };

type Props = {
  links: CrossLink[];
};

// Three contextual cross-links to sibling marketing pages. The anchor text is
// descriptive (no "hier klicken") to support SEO.
export default function InternalCrossLinks({ links }: Props) {
  return (
    <section style={{ padding: "20px 0 12px" }}>
      <Eyebrow>Mehr erfahren</Eyebrow>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 10,
        }}
      >
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
              padding: "14px 16px",
              background: "var(--paper-50)",
              border: "1px solid rgba(43,26,15,0.10)",
              borderRadius: 10,
              textDecoration: "none",
              color: "var(--ink)",
            }}
          >
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontFamily: "var(--f-display)",
                  fontStyle: "italic",
                  fontSize: 18,
                  color: "var(--oxblood)",
                }}
              >
                {l.label}
              </div>
              <div
                style={{
                  fontFamily: "var(--f-body)",
                  fontSize: 14,
                  lineHeight: 1.45,
                  color: "var(--ink-soft)",
                  marginTop: 2,
                }}
              >
                {l.blurb}
              </div>
            </div>
            <div
              style={{
                color: "var(--oxblood)",
                paddingTop: 4,
                flexShrink: 0,
              }}
            >
              <ArrowRightIcon />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
